import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a17354fc40fcccbeb1d1d5d214ec4ca7fb from "./generated-83cdf255-4ea4-41ba-9075-3a6f7cd9f013.json";

import abdc246653813d404ad263d564278a940b from "./generated-5f87b856-89a5-48d6-9b38-38f6c98ee8e1.json";

import acc34483df76bff1477c55d81b4dbcc24b from "./generated-663b9dda-5ab0-4b1d-b23f-e79edc4be36b.json";

import a59b68c4f981033c3aae5581b540e3987b from "./generated-ef10726d-b23f-4669-99e2-60007ee00af5.json";

import ab4a6db82086baaa639bd37bfb69e4593b from "./generated-986072cf-15e8-43d9-b17a-396598f7f63c.json";

import a740024b644fbaa029ddf7cd44914ce50b from "./generated-44f6f131-cfc4-42ab-8cc9-e4f2a118158e.json";

import ae907fe0015612d86f584c27c10871a7eb from "./generated-326d0d48-4393-40a9-b732-668215eee69d.json";

import ab329e89b36f9fbb167f526aeb1585598b from "./generated-249d7da7-427f-45fb-b387-d3900d4273be.json";

import a876f342b79fea3781b4bd416d9e41961b from "./generated-d339d156-0026-4366-978a-43f43bf333a4.json";

import acbef8a1cfe43cdc862a443de27118d8fb from "./generated-6c4da710-e428-46d1-828b-df3a50ffad68.json";

import aba9fcfc2d3011b480ed09e61b30b9e8cb from "./generated-8f14919d-759d-4b12-8f7f-1ff2a45af536.json";

import afe87808f3e88fb20790a013c83da828ab from "./generated-8a16fa66-97c7-499f-84e2-02d2b2149077.json";

import a660534a76a74a2af611df4999389e075b from "./generated-dde2d3c5-ec2f-4bf3-afc0-dd775abcacd3.json";

import aed2fad037ee2539d95cf2efe3870ee4cb from "./generated-4bf34c82-b599-4ffa-962e-e4e01a2a9066.json";

import af2cf965fe6b978a52e7a3c8e3ea334fdb from "./generated-dfd2c7a2-d613-4283-8686-8caacc56225b.json";

import abfdcef0bf4e6b48cf57392677e0a465db from "./generated-c816230b-db31-45d1-ae63-c17eb0470d18.json";

import a08124f41c1e53fa05225eaaf57c20799b from "./generated-66f1dd6b-f4b5-4240-811c-64394be0f544.json";

import af4713b6550c427370e7b0de83db83401b from "./generated-afa7041a-c060-4cca-af46-5f0c1ead0617.json";

import a201f028b798be30220ce787c69c79303b from "./generated-3e13e515-aaf0-40d2-af36-003dd04a2571.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a17354fc40fcccbeb1d1d5d214ec4ca7fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(abdc246653813d404ad263d564278a940b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(acc34483df76bff1477c55d81b4dbcc24b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a59b68c4f981033c3aae5581b540e3987b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ab4a6db82086baaa639bd37bfb69e4593b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a740024b644fbaa029ddf7cd44914ce50b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ae907fe0015612d86f584c27c10871a7eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab329e89b36f9fbb167f526aeb1585598b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a876f342b79fea3781b4bd416d9e41961b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(acbef8a1cfe43cdc862a443de27118d8fb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aba9fcfc2d3011b480ed09e61b30b9e8cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(afe87808f3e88fb20790a013c83da828ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a660534a76a74a2af611df4999389e075b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aed2fad037ee2539d95cf2efe3870ee4cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(af2cf965fe6b978a52e7a3c8e3ea334fdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(abfdcef0bf4e6b48cf57392677e0a465db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a08124f41c1e53fa05225eaaf57c20799b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(af4713b6550c427370e7b0de83db83401b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a201f028b798be30220ce787c69c79303b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a08124f41c1e53fa05225eaaf57c20799b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */